/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoriesPage_allCategories$ref = any;
export type queries_CategoriesPage_recipes_QueryVariables = {||};
export type queries_CategoriesPage_recipes_QueryResponse = {|
  +$fragmentRefs: CategoriesPage_allCategories$ref
|};
export type queries_CategoriesPage_recipes_Query = {|
  variables: queries_CategoriesPage_recipes_QueryVariables,
  response: queries_CategoriesPage_recipes_QueryResponse,
|};
*/


/*
query queries_CategoriesPage_recipes_Query {
  ...CategoriesPage_allCategories
}

fragment CategoriesPage_allCategories on Query {
  allCategories(first: 20) {
    totalCount
    edges {
      node {
        id
        name
        picture
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_CategoriesPage_recipes_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CategoriesPage_allCategories"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_CategoriesPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "allCategories(first:20)"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "name"
        ],
        "handle": "connection",
        "key": "Categories_allCategories",
        "kind": "LinkedHandle",
        "name": "allCategories"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_CategoriesPage_recipes_Query",
    "operationKind": "query",
    "text": "query queries_CategoriesPage_recipes_Query {\n  ...CategoriesPage_allCategories\n}\n\nfragment CategoriesPage_allCategories on Query {\n  allCategories(first: 20) {\n    totalCount\n    edges {\n      node {\n        id\n        name\n        picture\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c3e2acf3e0f730b297b42de7b00769f';

module.exports = node;
